module.exports = __webpack_public_path__ + "img/P2.f07f5bfc.png";